import React ,{ forwardRef} from "react";
import { Container, Input, Label } from './styles'

const Checkbox =  forwardRef((props , ref) => {
    
    return (
        <Container  style={props.style} >
            <Input 
                type='checkbox'
                name={props.name}
                {...props.register}
                {...props.setValue}
                id={props.id}
                ref={ref}
                value={props.value}
                checked={props.checked}
                disabled={props.disabled}
                onChange={props.onChange} />
            <Label>{props.title}</Label>
        </Container>

    )
    }
)

export default Checkbox;